import barba from '@barba/core';
import tippy from 'tippy.js';

const initClipboardText = () => {
	const clipboardTexts = document.querySelectorAll('[data-clipboard-text]:not(.is-initialized)');

	clipboardTexts.forEach((clipboardText) => {
		clipboardText.classList.add('is-initialized');
		let flashTipTimeouts = [];
		const tip = tippy(clipboardText, {
			content: wkScriptVars.tip_copied,
			allowHTML: true,
			trigger: 'manual',
		});
		clipboardText.addEventListener('click', (e) => {
			const text = clipboardText.getAttribute('data-clipboard-text');
			if (navigator.clipboard) {
				navigator.clipboard.writeText(text).then(() => {
					flashTipTimeouts.forEach((timeout) => clearTimeout(timeout));
					tip.show();
					flashTipTimeouts.push(setTimeout(() => tip.hide(), 1000));
				});
			}
		});
	});
};

barba.hooks.beforeEnter(initClipboardText);
document.addEventListener("DOMContentLoaded", initClipboardText);
